import {gql} from '@apollo/client';

export const REFERRAL_PARTNER_OVERVIEW = gql`
  query ReferralPartnerGetOverview($input: ReferralPartnerFilterInput) {
    referralPartnerGetOverview(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ReferralPartnerOverview {
        totalEarnings
        totalVolume
        totalReferees
        activeReferees
        inactiveReferees
        avgEarningsPerReferee
        currency
        totalAcademyEarnings
        totalAcademySales
        totalAcademyVolume
      }
    }
  }
`;

export const REFERRAL_PARTNER_REFEREES = gql`
  query ReferralPartnerGetReferees($input: ReferralPartnerFilterInput) {
    referralPartnerGetReferees(input: $input) {
      ... on ReferralPartnerRefereesResponse {
        page
        totalDocs
        hasPrevPage
        hasNextPage
        prevPage
        nextPage
        offset
        referees {
          id
          fullName
          email
          dateSignedUp
          hasSettledOrder
          totalInvested
          hasPurchasedAcademy
          totalAcademySpend
        }
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

export const ADMIN_TOTAL_EARNINGS_PAID_OUT = gql`
  query AdminGetTotalEarningsPaidOut($partnerId: ID!) {
    adminGetTotalEarningsPaidOut(partnerId: $partnerId) {
      ... on ReferralPartnerEarningsPaidOut {
        totalPaidOut
        totalPending
        paidOutCount
        pendingCount
        currency
        __typename
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

export const REFERRAL_PARTNER_MONTHLY_BREAKDOWN = gql`
  query ReferralPartnerGetMonthlyBreakdown($input: ReferralPartnerFilterInput) {
    referralPartnerGetMonthlyBreakdown(input: $input) {
      ... on ReferralPartnerMonthlyBreakdownResponse {
        page
        totalDocs
        hasPrevPage
        hasNextPage
        prevPage
        nextPage
        offset
        breakdown {
          id
          period
          status
          totalCommission
          fees
          volumeGenerated
          platformFees
          totalNewInvestedUsers
          commissionDueOnNewInvestedUsers
          currency
          academySalesCount
          academyVolume
          commissionDueOnAcademySales
        }
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

export const UPDATE_PARTNER_EARNING_STATUS = gql`
  mutation AdminUpdateReferralPartnerEarningStatus(
    $data: AdminUpdateEarningPaymentStatusInput!
  ) {
    adminUpdateReferralPartnerEarningStatus(data: $data) {
      ... on AdminUpdateEarningPaymentStatusResponse {
        success
        message
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const REFERRAL_PARTNER_EARNINGS_SUMMARY = gql`
  query ReferralPartnerGetEarningsSummary($input: ReferralPartnerFilterInput) {
    referralPartnerGetEarningsSummary(input: $input) {
      ... on ReferralPartnerEarningsSummary {
        totalEarnings
        averageMonthly
        growthRate
        currency
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;
